import { inject, Injectable } from '@angular/core';
import { ENVIRONMENT_CONFIG } from '@core/config-angular';
import { DomService, ScriptInjectOn } from '@innogy/utils-dom';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { tap } from 'rxjs';

import { MemberGetMemberService } from '../member-get-member-service/member-get-member.service';
import {
  loadMGMPingScriptAction,
  memberGetMemberSaleSubmit,
} from './member-get-member-state.actions';

@Injectable()
export class MemberGetMemberEffects {
  private readonly actions$ = inject(Actions);
  private readonly service = inject(MemberGetMemberService);
  private readonly domService = inject(DomService);
  readonly config = inject(ENVIRONMENT_CONFIG);

  public readonly loadMGMPingScript$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(loadMGMPingScriptAction),
        tap(() => {
          this.domService.injectScript({
            src: this.config.mgm.pingUrl,
            injectOnPlatform: ScriptInjectOn.CLIENT_ONLY,
            async: true,
          });
        })
      ),
    { dispatch: false }
  );

  public readonly submitMGMSale$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(memberGetMemberSaleSubmit),
        tap(({ payload }) => {
          this.service.ping(payload);
        })
      ),
    {
      dispatch: false,
    }
  );
}
